import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import {
  FeatureFilterField,
  FeatureName,
  UserFilterValues,
} from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';

import EditAddress from './Pages/EditAddress';
import { EditBankDetails } from './Pages/EditBankDetails';
import EditEmail from './Pages/EditEmail';
import Profile from './Pages/Profile';
import * as routes from './routes';

const ProfileRoutes: FC = () => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  const canAccessBankDetails = canAccessFeature({
    name: FeatureName.RequestExpenseclaims,
    where: {
      or: [
        {
          field: FeatureFilterField.User,
          values: [UserFilterValues.Self],
        },
      ],
    },
  });
  const canEditPersonalAddress = canAccessFeature({
    name: FeatureName.UserProfileWriteAddress,
  });
  return (
    <Switch>
      {canEditPersonalAddress ? (
        <Route component={EditAddress} path={routes.editAddress} />
      ) : null}
      <Route component={EditEmail} path={routes.editEmail} />
      <Route component={Profile} exact path={routes.root} />
      {canAccessBankDetails ? (
        <Route
          component={EditBankDetails}
          exact
          path={routes.editBankDetails}
        />
      ) : null}
    </Switch>
  );
};

export default ProfileRoutes;
